<template>
  <AGTag class="ag-tag-classificacao-analise" readonly :style="computedStyles" :label="computedLabel" />
</template>
<script>
import AGTag from '@/components/common/AGTag.vue';
import CLASSIFICACAO_ANALISE from '@/constants/ConstantClassificacaoAnalise';
import UtilsAnalise from '@/utils/UtilsAnalise';
export default {
  components: {
    AGTag,
  },

  props: {
    classificacao: {
      type: String || Object,
      validator: (val) => Object.values(CLASSIFICACAO_ANALISE).includes(val),
    },
  },

  computed: {
    computedLabel() {
      const description = UtilsAnalise.getDescriptionForClassificacao(this.classificacao);
      return description ?? 'Em análise';
    },

    computedStyles() {
      const validKeys = Object.values(CLASSIFICACAO_ANALISE);
      const key = validKeys.includes(this.classificacao) ? this.classificacao : CLASSIFICACAO_ANALISE.EM_ANALISE;
      const normalizedKey = [CLASSIFICACAO_ANALISE.NAO_UTILIZADA].includes(key)
        ? CLASSIFICACAO_ANALISE.NAO_UTILIZADA
        : key;
      const colors = UtilsAnalise.getColorForClassificacao(normalizedKey);
      return {
        backgroundColor: colors.backgroundColor,
        color: colors.textColor,
        borderColor: colors.borderColor,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.ag-tag-classificacao-analise {
  border: none;
}
</style>
